__webpack_require__.p = "/lakovna/";